// extracted by mini-css-extract-plugin
export var container = "_ag-1";
export var cornerButtonContainer = "_ag-5";
export var disabled = "_ag-2";
export var fileContainer = "_ag-4";
export var hiddenInput = "_ag-3";
export var widthContainer = "_ag-0";